import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import { communicationManager } from "./communicationManager";

class ClientManager extends Controller {
	constructor () {
		super("clientManager");
		this.remoteClassName = "client";
	}

	async checkFolders (guid) {
		const rd = NousCore.api.createRequest({ item: { createOnMissing: true, guid } });
		const requestedAction = "check-folders";


		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
		
	cancelDeleteRequest (client) {
		client.status = client.extraData.previousStatus !== 0 ? client.extraData.previousStatus : 1;

		const rd = NousCore.api.createRequest({ item: client.export() });
		const requestedAction = "update";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const pendingDeleteRequestList = Shark.get("pendingDeleteRequestList").filter(item => item.guid !== client.guid);
						// const clientIndex = Utils.safp(pendingDeleteRequestList, "guid", client.guid, "index");

						// if (clientIndex > -1) {
							// pendingDeleteRequestList.splice(clientIndex, 1);
							Shark.set({
								pendingDeleteRequestList,
							});
						// }
						return {
							data: pendingDeleteRequestList,
							status: "ok",
						}
					case 404:
						return {
							data,
							status: "ko",
						}
					}
			}
		});
	}

	confirmDeleteRequest (client) {
		const rd = NousCore.api.createRequest({ item: client.export() });
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const pendingDeleteRequestList = Shark.get("pendingDeleteRequestList").filter(item => item.guid !== client.guid);
						// const pendingDeleteRequestList = Shark.get("pendingDeleteRequestList").map(item => item);
						// const clientIndex = Utils.safp(pendingDeleteRequestList, "guid", client.guid, "index");

						// if (clientIndex > -1) {
						// 	pendingDeleteRequestList.splice(clientIndex, 1);
						// 	Shark.set("pendingDeleteRequestList", pendingDeleteRequestList);
						// }
						Shark.set({
							pendingDeleteRequestList,
						});
						return {
							data: pendingDeleteRequestList,
							status: "ok",
						}
					case 404:
						clientManager.emit("prospectDeleteError");
						return {
							data,
							status: "ko",
						}
					}
			}
		});
	}

	delete (client) {
		if (!Array.isArray(client)) {
			client = [client];
		}

		const rd = NousCore.api.createRequest({ items: client.map(item => {return {guid: item.guid}}) });
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data,
							requestedAction,
							status: "ok"
						}
					case 404:
						return {
							data: "",
							requestedAction,
							status: "ko"
						}
				}
			}
		});
	}

	getByGuid (guid) {
		const rd = NousCore.api.createRequest({ item: { guid: guid } });
	
		return NousCore.api.send("client/get-by-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						let client;
						
						if (data.items.length > 0) {
							client = Shark.getInstance("Client", data.items[0]);
						}
	
						return {
							data: client,
							status: "ok",
						}
					case 404:
						return {
							data,
							status: "ko",
						}
				}
			}
		});
	}

	getFilteredLeadList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}, preventNameSorting = false) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-lead-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						Shark.set("prospectAvailableItemCount", data.availableItemCount);
						let prospectList = Shark.getInstanceList("Client", data.items);

						if (incrementalRequest) {
							prospectList = [...Shark.get("prospectList"), ...prospectList];
						}

						if (!preventNameSorting) {
							prospectList.sort((a, b) => {
									if (a.name.toLowerCase() > b.name.toLowerCase()) {
									return 1;
								}
								else if (a.name.toLowerCase() < b.name.toLowerCase()) {
									return -1
								}
							});
						}

						Shark.set({
							prospectList,
							__prospectListRetrieved: true,
							__prospectListNeedFurtherLoad: data.availableItemCount > prospectList.length,
							__availableFurtherItems: data.availableItemCount - prospectList.length,
						});

						clientManager.emit("prospectListChanged");
						return {
							data: prospectList,
							requestedAction,
							status: "ok",
						}
					case 404:
						clientManager.emit("prospectListGetError");
						return {
							data: null,
							error: data.error,
							requestedAction,
							status: "ko",
						}
				}
			}
		});
	}

	getList (range) {
		const clientListActiveFilters = Shark.get("clientListActiveFilters");
		const searchStatus = [];

		if (clientListActiveFilters && clientListActiveFilters.showActive) {
			searchStatus.push(1);
		}
		if (clientListActiveFilters && clientListActiveFilters.showArchived) {
			searchStatus.push(8);
		}

		const rd = NousCore.api.createRequest({ item: { status: searchStatus } });
		let firstRowIndex = 1;

		if (range) {
			rd.range = range;
			firstRowIndex = range.first + 1;
		}

		// if (filters) {
		// 	rd.filters = filters;
		// }
		
		console.time("clientList")
		return NousCore.api.send("client/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						Shark.set("clientAvailableItemCount", data.availableItemCount);
						let clientList = Shark.getInstanceList("Client", data.items);

						// if (incrementalRequest) {
						// 	clientList = [...Shark.get("clientList"), ...clientList];
						// }


						console.timeEnd("clientList")

						Shark.set({
							clientList,
							// clientListHome: clientList.filter((item, index) => index < 100),
							__clientListNeedFurtherLoad: data.availableItemCount > clientList.length,
							__availableFurtherItems: data.availableItemCount - clientList.length,
						});

						// clientManager.emit("listChanged");
						return {
							data: clientList,
							requestedAction: "get-list",
							status: "ok",
						}
					case 404:
						// clientManager.emit("listGetError");
						return {
							data: null,
							error: data.error,
							requestedAction: "get-list",
							status: "ko",
						}
				}
			}
		});
	}
	
	getListByGuidList (guidList, filters) {
		const rd = NousCore.api.createRequest({item: {guidList} });
		const requestedAction = "get-list-by-guid-list";

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						let contactList = Shark.getInstanceList("Client", data.items);
						const rawData = Shark.getInstanceList("__smart__", data.items);

						contactList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1
							}
						});

						return {
							data: {
								contactList,
								rawData,
							},
							requestedAction,
							status: "ok",
						}
					case 404:
						return {
							data: null,
							error: data.error,
							requestedAction,
							status: "ko",
						}
				}
			}
		});
	}

	getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const clientListActiveFilters = Shark.get("clientListActiveFilters");
		const searchStatus = [];

		if (clientListActiveFilters && clientListActiveFilters.showActive) {
			searchStatus.push(1);
		}
		if (clientListActiveFilters && clientListActiveFilters.showArchived) {
			searchStatus.push(8);
		}

		const rd = NousCore.api.createRequest({ item: { status: searchStatus } });
		let firstRowIndex = 1;

		if (range) {
			rd.range = range;
			firstRowIndex = range.first + 1;
		}

		if (filters) {
			rd.filters = filters;
		}
		
		console.time("clientList")
		return NousCore.api.send("client/get-filtered-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						Shark.set("clientAvailableItemCount", data.availableItemCount);
						let clientList = Shark.getInstanceList("Client", data.items);

						if (incrementalRequest) {
							clientList = [...Shark.get("clientList"), ...clientList];
						}


						console.timeEnd("clientList")

						Shark.set({
							clientList,
							// clientListHome: clientList.filter((item, index) => index < 100),
							__clientListNeedFurtherLoad: data.availableItemCount > clientList.length,
							__availableFurtherItems: data.availableItemCount - clientList.length,
						});

						// clientManager.emit("listChanged");
						return {
							data: clientList,
							requestedAction: "get-filtered-list",
							status: "ok",
						}
					case 404:
						// clientManager.emit("listGetError");
						return {
							data: null,
							error: data.error,
							requestedAction: "get-filtered-list",
							status: "ko",
						}
				}
			}
		});
	}

	reassignContactToAgent (reassignSettings) {
		const rd = NousCore.api.createRequest({ item: reassignSettings.export() });
		const requestedAction = "reassign-contact-to-agent";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							status: "ok",
						}
					case 404:
						return {
							data,
							status: "ko",
						}
					}
			}
		});
	}

	reassignProspectBranchToLead (reassignProspectBranchToLeadSettings) {
		const rd = NousCore.api.createRequest({ item: reassignProspectBranchToLeadSettings.export() });
		const requestedAction = "reassign-prospect-branch-to-lead";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							status: "ok",
						}
					case 404:
						return {
							data,
							status: "ko",
						}
					}
			}
		});
	}

	search (filters) {
		// {name: searchKey}
		const rd = NousCore.api.createRequest({ filters });
		const requestedAction = "search";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const contactList = Shark.getInstanceList("Client", data.items);

						contactList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
						});
	
						return {
							data: contactList,
							requestedAction,
							status: "ok"
						}
					case 99:
						return {
							data,
							requestedAction,
							status: "ko"
						}
				}
			}
		});
	}

	setLeadAsNotInterested (updatedProspectList) {
		const rd = NousCore.api.createRequest({ items: updatedProspectList.map(item => item.export()) });
		const requestedAction = "set-lead-as-not-interested";

		return NousCore.api.send(`client/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						updatedProspectList.forEach((item, index) => item.import(data.items[index]));
						const prospectList = Shark.get("prospectList").filter(item => item.status === 3);

						Shark.set("prospectList", prospectList);

						return {
							data: prospectList,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}





	
	deleteProspect (prospectToDeleteList) {
		const rd = NousCore.api.createRequest({ items: prospectToDeleteList.map(item => item.export()) });

		NousCore.api.send("client/delete", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const deleteGuidList = prospectToDeleteList.map(item => item.guid);
						const prospectList = Shark.get("prospectList").filter(item => deleteGuidList.indexOf(item.guid) === -1);

						Shark.set("prospectList", prospectList);

						clientManager.emit("prospectDeleted");
						break;
					case 404:
						clientManager.emit("prospectDeleteError");
						break;
				}
			}
		});
	}

	getFullReportList (client) {
		const rd = NousCore.api.createRequest({ item: {dateEnd: "2020-12-31", dateStart: "2019-01-01"} });

		return NousCore.api.send("client/get-full-report-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						console.log({client, data});

						const fullReportList = Shark.getInstanceList(null, data.items);
						Shark.set({fullReportList});

						// const item = data.items[0];
						
						// // item.clientName = client.clientName || client.prospectName;
						// item.quotationPendingCount = parseInt(item.quotationPendingCount);
						// item.quotationAcceptedCount = parseInt(item.quotationAcceptedCount);
						// item.quotationRefusedCount = parseInt(item.quotationRefusedCount);
						// item.quotationCount = item.quotationPendingCount + item.quotationAcceptedCount + item.quotationRefusedCount;
						
						// item.siteInfoSheetCount = parseInt(item.siteInfoSheetCount);

						return {
							data: fullReportList,
							status: "ok",
						}
					case 404:
						return {
							data: "",
							status: "ko",
						}
				}
			}
		});
	}

	getFullReport (client) {
		const rd = NousCore.api.createRequest({ item: { guid: client.guid } });

		return NousCore.api.send("client/get-full-report", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						console.log({client, data});

						const item = data.items[0];
						
						// item.clientName = client.clientName || client.prospectName;
						item.constructionSiteCardCount = parseInt(item.constructionSiteCardCount);
						item.constructionSiteCardCustomerCount = parseInt(item.constructionSiteCardCustomerCount);
						item.constructionSiteCardDesignerCount = parseInt(item.constructionSiteCardDesignerCount);
						item.constructionSiteCardEndUserCount = parseInt(item.constructionSiteCardEndUserCount);

						item.constructionSiteClosedCount = parseInt(item.constructionSiteClosedCount);
						item.constructionSiteClosedCustomerCount = parseInt(item.constructionSiteClosedCustomerCount);
						item.constructionSiteClosedDesignerCount = parseInt(item.constructionSiteClosedDesignerCount);
						item.constructionSiteClosedEndUserCount = parseInt(item.constructionSiteClosedEndUserCount);

						item.constructionSiteProblematicCount = parseInt(item.constructionSiteProblematicCount);
						item.constructionSiteProblematicCountLabel = `${item.constructionSiteProblematicCount} cantier${item.constructionSiteProblematicCount === 1 ? "e" : "i"}`;
						item.constructionSiteProblematicCustomerCount = parseInt(item.constructionSiteProblematicCustomerCount);
						item.constructionSiteProblematicDesignerCount = parseInt(item.constructionSiteProblematicDesignerCount);
						item.constructionSiteProblematicEndUserCount = parseInt(item.constructionSiteProblematicEndUserCount);

						item.constructionSiteStartedCount = parseInt(item.constructionSiteStartedCount);
						item.constructionSiteStartedCustomerCount = parseInt(item.constructionSiteStartedCustomerCount);
						item.constructionSiteStartedDesignerCount = parseInt(item.constructionSiteStartedDesignerCount);
						item.constructionSiteStartedEndUserCount = parseInt(item.constructionSiteStartedEndUserCount);

						item.constructionSiteWaitingCount = parseInt(item.constructionSiteWaitingCount);
						item.constructionSiteWaitingCustomerCount = parseInt(item.constructionSiteWaitingCustomerCount);
						item.constructionSiteWaitingDesignerCount = parseInt(item.constructionSiteWaitingDesignerCount);
						item.constructionSiteWaitingEndUserCount = parseInt(item.constructionSiteWaitingEndUserCount);

						item.constructionSiteTotalCount = item.constructionSiteClosedCount /*+ item.constructionSiteProblematicCount*/ + item.constructionSiteStartedCount + item.constructionSiteWaitingCount;
						item.constructionSiteTotalCustomerCount = item.constructionSiteClosedCustomerCount + /*item.constructionSiteProblematicCustomerCount*/ + item.constructionSiteStartedCustomerCount + item.constructionSiteWaitingCustomerCount;
						item.constructionSiteTotalDesignerCount = item.constructionSiteClosedDesignerCount + /*item.constructionSiteProblematicDesignerCount*/ + item.constructionSiteStartedDesignerCount + item.constructionSiteWaitingDesignerCount;
						item.constructionSiteTotalEndUserCount = item.constructionSiteClosedEndUserCount + /*item.constructionSiteProblematicEndUserCount*/ + item.constructionSiteStartedEndUserCount + item.constructionSiteWaitingEndUserCount;
						
						item.notComplianceReportCount = parseInt(item.notComplianceReportCount);
						item.notComplianceReportCountLabel = `${item.notComplianceReportCount} rapport${item.notComplianceReportCount === 1 ? "o" : "i"}`;

						item.quotationPendingCount = parseInt(item.quotationPendingCount);
						item.quotationAcceptedCount = parseInt(item.quotationAcceptedCount);
						item.quotationRefusedCount = parseInt(item.quotationRefusedCount);

						item.quotationAcceptedCustomerCount = parseInt(item.quotationAcceptedCustomerCount);
						item.quotationAcceptedDesignerCount = parseInt(item.quotationAcceptedDesignerCount);
						item.quotationAcceptedEndUserCount = parseInt(item.quotationAcceptedEndUserCount);

						item.quotationPendingCustomerCount = parseInt(item.quotationPendingCustomerCount);
						item.quotationPendingDesignerCount = parseInt(item.quotationPendingDesignerCount);
						item.quotationPendingEndUserCount = parseInt(item.quotationPendingEndUserCount);

						item.quotationRefusedCustomerCount = parseInt(item.quotationRefusedCustomerCount);
						item.quotationRefusedDesignerCount = parseInt(item.quotationRefusedDesignerCount);
						item.quotationRefusedEndUserCount = parseInt(item.quotationRefusedEndUserCount);

						item.quotationCustomerCount = item.quotationPendingCustomerCount + item.quotationAcceptedCustomerCount + item.quotationRefusedCustomerCount;
						item.quotationDesignerCount = item.quotationPendingDesignerCount + item.quotationAcceptedDesignerCount + item.quotationRefusedDesignerCount;
						item.quotationEndUserCount = item.quotationPendingEndUserCount + item.quotationAcceptedEndUserCount + item.quotationRefusedEndUserCount;

						// item.quotationPendingCount = item.quotationPendingCustomerCount + item.quotationPendingDesignerCount + item.quotationPendingEndUserCount;
						// item.quotationAcceptedCount = item.quotationAcceptedCustomerCount + item.quotationAcceptedDesignerCount + item.quotationAcceptedEndUserCount;
						// item.quotationRefusedCount = item.quotationRefusedCustomerCount + item.quotationRefusedDesignerCount + item.quotationRefusedEndUserCount;

						item.quotationCount = item.quotationPendingCount + item.quotationAcceptedCount + item.quotationRefusedCount;
						
						item.siteInfoSheetCount = parseInt(item.siteInfoSheetCount);
						item.siteInfoSheetCustomerCount = parseInt(item.siteInfoSheetCustomerCount);
						item.siteInfoSheetDesignerCount = parseInt(item.siteInfoSheetDesignerCount);
						item.siteInfoSheetEndUserCount = parseInt(item.siteInfoSheetEndUserCount);

						return {
							data: item,
							status: "ok",
						}
					case 404:
						return {
							data: "",
							status: "ko",
						}
				}
			}
		});
	}

	getListByAgent (user, includeNotConfirmed) {
		const rd = NousCore.api.createRequest({ item: { guid: user.guid, includeNotConfirmed } });

		return NousCore.api.send("client/get-list-by-agent", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const clientList = Shark.getInstanceList("Client", data.items);

						clientList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
						});

						// const contactListProvinceForFilter = new Set();
						// clientList.forEach(item => item.province !== "" ? contactListProvinceForFilter.add(item.province) : false);

						// appointmentManager.matchClient(clientList, Shark.get("appointmentList"));

						console.log({clientList})
						Shark.set({
							clientList,
							// contactListProvinceForFilter: Array.from(contactListProvinceForFilter).sort(),
						});

						// clientManager.emit("listChanged");
						return {
							data: clientList,
							requestedAction: "get-list-by-agent",
							status: "ok",
						}
					case 404:
						// clientManager.emit("listGetError");
						return {
							data: "",
							requestedAction: "get-list-by-agent",
							status: "ko",
						}
				}
			}
		});
	}

	getPendingDeleteRequest () {
		const rd = NousCore.api.createRequest();

		NousCore.api.send("client/get-pending-delete-request", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const pendingDeleteRequestList = Shark.getInstanceList("Client", data.items);
						Shark.set("pendingDeleteRequestList", pendingDeleteRequestList);
						// const deleteGuidList = prospectToDeleteList.map(item => item.guid);
						// const prospectList = Shark.get("prospectList").filter(item => deleteGuidList.indexOf(item.guid) === -1);
						// Shark.set("prospectList", prospectList);
						// clientManager.emit("prospectDeleted");
						break;
					case 404:
						clientManager.emit("prospectDeleteError");
						break;
				}
			}
		});
	}

	// getProspectList (range) {
	// 	const rd = NousCore.api.createRequest();
	// 	let firstRowIndex = 1;

	// 	if (range) {
	// 		rd.range = range;
	// 		firstRowIndex = range.first + 1;
	// 	}

	// 	return NousCore.api.send("client/get-prospect-list", rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					Shark.set("prospectAvailableItemCount", data.availableItemCount);
	// 					let prospectList = Shark.getInstanceList("Client", data.items);

	// 					prospectList.sort((a, b) => {
	// 						if (a.name.toLowerCase() > b.name.toLowerCase()) {
	// 							return 1;
	// 						}
	// 						else if (a.name.toLowerCase() < b.name.toLowerCase()) {
	// 							return -1
	// 						}
	// 					});

	// 					//Questo forse serve
	// 					// prospectList.forEach((item, index) => {
	// 					// 	item.__displayIndex = firstRowIndex + index;
	// 					// });

	// 					// tableSorterComponent.set({
	// 					// 	tableContentList: prospectList
	// 					// });

	// 					// followUpComponent.set({
	// 					// 	sourceList: prospectList
	// 					// });

	// 					Shark.set({
	// 						prospectList,
	// 						__prospectListRetrieved: true
	// 					});

	// 					clientManager.emit("prospectListChanged");
	// 					return {
	// 						data: prospectList,
	// 						requestedAction: "get-prospect-list",
	// 						status: "ok",
	// 					}
	// 				case 404:
	// 					clientManager.emit("prospectListGetError");
	// 					return {
	// 						data: null,
	// 						error: data.error,
	// 						requestedAction: "get-prospect-list",
	// 						status: "ko",
	// 					}
	// 			}
	// 		}
	// 	});
	// });

	getProspectRecap () {
		const rd = NousCore.api.createRequest();

		NousCore.api.send("client/get-prospect-recap", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const prospectRecap = {
							expired: 0,
							notAssigned: 0,
							pending: 0,
						};
						let prospectTotalCount = 0;

						data.items.forEach(item => {
							const intVal = parseInt(item.pastDays);
							if (!isNaN(intVal)) {
								switch (intVal) {
									case 0:
									case 1:
									case 2:
									case 3:
										prospectRecap.pending += parseInt(item.clientCount);
										break;
									default:
										prospectRecap.expired += parseInt(item.clientCount);
										break;
								}
							}
							else {
								prospectRecap.notAssigned += parseInt(item.clientCount);
							}
							prospectTotalCount += parseInt(item.clientCount);
						});

						console.log(prospectRecap);

						Shark.set({
							prospectRecap,
							prospectTotalCount
						});
						break;
					case 404:
						// clientManager.emit("prospectDeleteError");
						break;
				}
			}
		});
	}

	getListByGuid (id) {
		const rd = NousCore.api.createRequest({ item: { guid: id } });

		NousCore.api.send("client/get-list-by-agent", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						Shark.set("clientList", Shark.getInstanceList("Client", data.items));

						clientManager.emit("listChanged");
						break;
					case 404:
						clientManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (client) {
		const rd = NousCore.api.createRequest({ item: client.export() });
		const action = client.guid === "" ? "insert" : "update";

		return NousCore.api.send(`client/${action}`, rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						client.import(data.items[0]);
						client.clean();

						if (!client.enabled) {
							const clientList = Shark.get("clientList");
							const clientIndex = Utils.safp(clientList, "guid", client.guid, "index");
							if (clientIndex > -1) {
								clientList.splice(clientIndex, 1);
							}
						}

						clientManager.emit("clientSaved");
						return {
							data: client,
							status: "ok"
						}
					case 99:
						clientManager.emit("clientSaveError");
						return {
							data: null,
							status: "ko"
						}
				}
			}
		});
	}

	saveProspectList (prospectListToInsert) {
		const rd = NousCore.api.createRequest({ items: prospectListToInsert.map(item => item.export()) });
		const action = prospectListToInsert[0].guid === "" ? "insert" : "update";

		return new Promise((resolve, reject) => {
			NousCore.api.send(`client/${action}`, rd, function (data) {
				console.log(data);

				if (data.isSuccess) {
					switch (data.rc) {
						case 1:
							prospectListToInsert.forEach((item, index) => {
								item.import(data.items[index])
								item.clean();
							});

							if (action === "insert") {
								const prospectList = Shark.get("prospectList") || [];
								prospectList.push(...prospectListToInsert);
								
								prospectListToInsert.forEach(item => {
									if (item.extraData.leadIsPremium) {
										communicationManager.leadPremiumInserted(item);
									}
								});
							}
							// const clientList = [...Shark.get("clientList")];
							// Shark.set({clientList});
							// client.import(data.items[0]);
							// client.clean();

							// if (!client.enabled) {
							// 	const clientList = Shark.get("clientList");
							// 	const clientIndex = Utils.safp(clientList, "guid", client.guid, "index");
							// 	if (clientIndex > -1) {
							// 		clientList.splice(clientIndex, 1);
							// 	}
							// }
							resolve(prospectListToInsert);

							clientManager.emit("prospectListChanged");
							clientManager.emit("prospectSaved");
							break;
						case 99:
							reject({error: "prospectSaveError"});
							clientManager.emit("prospectSaveError");
							break;
					}
				}
			});
		});
	}


	updateProspect (updatedProspectList) {
		const rd = NousCore.api.createRequest({ items: updatedProspectList.map(item => item.export()) });

		//Dave.Warn: Sarebbe meglio avere un update-prospect lato api per questioni di permessi
		return NousCore.api.send("client/update", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						updatedProspectList.forEach((item, index) => item.import(data.items[index]));
						const prospectList = Shark.get("prospectList").filter(item => item.status === 3);

						Shark.set("prospectList", prospectList);

						clientManager.emit("prspectUpdated");
						return {
							data: prospectList,
							status: "ok"
						}
					case 404:
						clientManager.emit("prspectUpdateError");
						return {
							data,
							status: "ko"
						}
				}
			}
		});
	}
}

const clientManager = new ClientManager();


// upload (target) {
// 	NousCore.api.uploadFiles(target, "client/upload-picture").then(function(jsonData) {
// 		const savedFile = jsonData.payload.items[0];

// 		switch (savedFile.rc) {
// 			case 1:
// 				const client = Shark.get("editingClient");
// 				client.set("pictureURL", savedFile.filePath);
// 				clientManager.emit("fileUploaded", savedFile.filePath);
// 				break;
// 			case 95:
// 				let data = {
// 					tempFile: savedFile.errors[0].erroData.tempFile,
// 					originalName: savedFile.errors[0].erroData.originalName,
// 					type: "pictureURL"
// 				};
// 				clientManager.emit("fileAlreadyPresentError", data);
// 				break;
// 			default:
// 				alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
// 		}

// 		Shark.render();
// 	});
// });

// uploadDuplicate (datas) {
// 	const rd = NousCore.api.createRequest({ item: { tempFile: datas.tempFile, originalName: datas.originalName }});

// 	NousCore.api.send("client/confirm-temp-dupe-file", rd, function (data) {
// 		console.log(data);

// 		if (data.isSuccess) {
// 			switch (data.rc) {
// 				case 1:
// 					const editingClient = Shark.get("editingClient")
// 					editingClient.set(datas.type, data.items[0].filePath);
// 					Shark.render();
// 					break;
// 				case 404:
// 					clientManager.emit("clientSaveError");
// 					break;
// 			}
// 		}
// 	});
// });

Shark.registerController(clientManager);

export { clientManager };
